import { Box } from "@mui/joy";
import { createContext, ReactNode, useContext } from "react";

/**
 * Whether the desktop sidebar is expanded, or null outside the sidebar.
 *
 * Components shared with the mobile header, which has no provider, see null
 * there and never collapse.
 */
export const SidebarExpandedContext = createContext<boolean | null>(null);

export const useSidebarExpanded = () => useContext(SidebarExpandedContext) ?? true;

/** Text that shrinks to nothing when the sidebar collapses. */
export const CollapseText = ({ children }: { children: ReactNode }) => {
  const isExpanded = useContext(SidebarExpandedContext);
  if (isExpanded === null) {
    return <>{children}</>;
  }
  return (
    <Box
      component="span"
      sx={{
        display: "block",
        maxWidth: isExpanded ? 240 : 0,
        overflow: "hidden",
        transition: "max-width 0.3s",
      }}
    >
      {children}
    </Box>
  );
};
